import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { UpgradeModule } from "@angular/upgrade/static";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { UploadImagesComponent } from "./components/upload-images.component";
import { NgxUploaderModule } from "ngx-uploader";
import { PreviewImageComponent } from "./components/preview-image.component";
import { TemplateImagesService } from "./services/template-images.service";
import { BrowseUploadedImagesComponent } from "./components/browse-uploaded-images.component";
import { TreeModule } from "primeng/tree";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    UploadImagesComponent,
    PreviewImageComponent,
    BrowseUploadedImagesComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    TooltipModule,
    UpgradeModule,
    NgxUploaderModule,
    TreeModule,
    FormsModule,
  ],
  exports: [NgxUploaderModule],
  providers: [
    TemplateImagesService,
    {
      provide: "IMAGE_BASE_URL",
      useValue: "https://images.autoremind.us/",
    },
    {
      provide: "MAX_FILE_SIZE",
      useValue: 1000000,
    }
  ],
})
export class UploadImagesModule {}
